import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { Game, PaginatedGameResults } from '../services/backendService/types';
import { resultsCacheKey } from './useGames';

function useDeleteGame() {
  const client = useQueryClient();

  const { mutate: deleteGame, isLoading: isDeletingGame } = useMutation(
    ({
      config,
    }: {
      config: { gameId: string; templateId?: string };
      onSuccessFunction?: (data: Game) => void | undefined;
    }) => {
      return BackendService.instance.game.deleteGame(config.gameId);
    },
    {
      onMutate: data => {
        const templateId = data.config.templateId;
        const cacheKey = [resultsCacheKey, templateId];
        const previous = client.getQueryData<{ pages: PaginatedGameResults[] }>(cacheKey);
        client.setQueryData<{ pages: PaginatedGameResults[] } | undefined>(
          cacheKey,
          result => {
            if (!result) return result;
            const updatedPages = result.pages.map(p => {
              const updatedPageItems = p.items.filter(g => g.id !== data.config.gameId);
              return { ...p, items: updatedPageItems };
            });
            return { ...result, pages: updatedPages };
          },
        );

        return () => {
          client.setQueryData(cacheKey, previous);
        };
      },
      onSuccess: (data, { onSuccessFunction }) => {
        if (onSuccessFunction) {
          onSuccessFunction(data);
        }
      },
    },
  );

  return {
    deleteGame,
    isDeletingGame,
  };
}

export default useDeleteGame;
